import PropTypes from 'prop-types';
import classNames from 'classnames';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer,
  ReferenceDot,
  Tooltip
} from 'recharts';

import styles from '../calculator-results.module.scss';
const { chart_wrapper, hide_visual } = styles;

/**
 * Shared line chart component for calculator visualizations
 * Abstracts common Recharts configuration with flexible customization
 */
const CalculatorLineChart = ({
  data,
  lines,
  yAxisFormatter,
  tooltip,
  breakEvenPoint,
  condensed = false,
  hideVisual = false
}) => {
  return (
    <div
      className={classNames(chart_wrapper, {
        condensed: condensed,
        [hide_visual]: hideVisual
      })}
    >
      <ResponsiveContainer width="100%" height="100%">
        <LineChart
          data={data}
          margin={
            condensed
              ? { left: 5, right: 10, top: 5, bottom: 5 }
              : { left: 10, right: 20, top: 10, bottom: 10 }
          }
        >
          <CartesianGrid strokeDasharray="3 3" stroke="#e0e0e0" />
          <XAxis
            dataKey="month"
            tick={{ fontSize: 10 }}
            axisLine={{ stroke: '#666' }}
            tickLine={false}
            interval="preserveStartEnd"
            ticks={data.filter((_, index) => index % 6 === 0).map((d) => d.month)}
          />
          <YAxis
            tickFormatter={yAxisFormatter}
            axisLine={false}
            tickLine={false}
            fontSize={10}
            domain={['auto', 'auto']}
          />
          <Tooltip content={tooltip} />
          {lines.map((line) => (
            <Line
              key={line.dataKey}
              type="monotone"
              dataKey={line.dataKey}
              stroke={line.stroke}
              strokeWidth={2}
              dot={false}
              name={line.name}
            />
          ))}
          {breakEvenPoint && breakEvenPoint > 0 && breakEvenPoint.month !== undefined && (
            <ReferenceDot
              x={breakEvenPoint.month}
              y={breakEvenPoint.value}
              r={7}
              fill="#000"
              stroke="#f5f5f5"
              strokeWidth={6}
            />
          )}
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

CalculatorLineChart.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  lines: PropTypes.arrayOf(
    PropTypes.shape({
      dataKey: PropTypes.string.isRequired,
      stroke: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired
    })
  ).isRequired,
  yAxisFormatter: PropTypes.func.isRequired,
  tooltip: PropTypes.element.isRequired,
  breakEvenPoint: PropTypes.shape({
    month: PropTypes.number,
    value: PropTypes.number
  }),
  condensed: PropTypes.bool,
  hideVisual: PropTypes.bool
};

export default CalculatorLineChart;
